import React, { useState, useContext, useEffect } from "react"
import { myContext } from "../provider"

import "./styles/language-switcher.scss"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const LanguageSwitcher = () => {
  const context = useContext(myContext)
  const [activeLanguage, setActiveLanguage] = useState(context.currentLanguage)

  useEffect(() => {
    setActiveLanguage(context.currentLanguage)
  }, [context.currentLanguage])

  const switchLanguageWithDelay = () => {
    if (activeLanguage === "fr") {
      setActiveLanguage("en")
    } else {
      setActiveLanguage("fr")
    }
    setTimeout(() => {
      context.switchLanguage()
    }, 300)
  }

  return (
    <div
      className={`language-switcher ${
        activeLanguage === "fr" ? "icon-right" : "icon-left"
      }`}
      role="button"
      onClick={() => switchLanguageWithDelay()}
      onKeyDown={() => switchLanguageWithDelay()}
      tabIndex={0}
    >
      <div className={`switch fr ${activeLanguage === "fr" ? "active" : ""}`}>
        {" "}
      </div>
      <div className={`switch en ${activeLanguage === "en" ? "active" : ""}`}>
        {" "}
      </div>
      <div className="label">{activeLanguage}</div>
    </div>
  )
}

export default LanguageSwitcher
